import { request2 } from './request'
// 获取消息列表
export function GetPageList(params) {
    return request2({
        url: '/api2/TZsbAdminApi/Memorandum/GetPageList?a='+Math.random(),
        method: 'get',
        params: {
          // MemorandumCategory : params.MemorandumCategory,
          CategoryMemorandumId : params.CategoryMemorandumId,
          MessageReadingStatus : params.MessageReadingStatus,
          DespKeyword : params.DespKeyword,
          pageIndex : params.pageIndex,
          pageSize : params.pageSize,
      }
    })
}
// 阅读消息-单个
export function ReadMsg(id) {
  return request2({
      url: '/api2/TZsbAdminApi/Memorandum/ReadMsg',
      method: 'post',
      params: {
        id : id,
    }
  })
}
export function NotReadMsg(count) {
  return request2({
      url: '/api2/TZsbAdminApi/Memorandum/NotReadMsg',
      method: 'post',
      params: {
        count : count,
    }
  })
}

// 批量阅读
export function ReadMsgList(ids) {
  return request2({
      url: '/api2/TZsbAdminApi/Memorandum/ReadMsgList',
      method: 'post',
      data: ids
  })
}